const mEditionMapEnrollmentsStudentsModalCreate = {
  mEditionMapEnrollmentsStudentsModalCreate: {
    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        inscripcionRolExistenteHabilitado: 'La inscripción fue procesada exitosamente y se inscribio de forma inmediata, ya que el usuario ya pertenecía a la Academia.',
        inscripcionRolExistenteDeshabilitado: 'La inscripción fue procesada exitosamente y se inscribio de forma inmediata, pero su Rol de Alumno esta deshabilitado en la Academia.',
        inscripcionRolInmediato: 'La inscripción fue procesada exitosamente y se inscribio de forma inmediata, ya que el usuario ya pertenecía a la Academia.',
        proyectoRolExistenteHabilitado: 'El Alumno ya pertenece al Curso y su Rol se encuentra habilitado.',
        proyectoRolExistenteDeshabilitado: 'El Alumno ya pertenece al Curso pero su Rol de Alumno esta deshabilitado en la Academia.',
        success: 'La inscripción fue procesada exitosamente. El alumno recibirá un email de notificación para hacerle saber que su inscripción ha sido dada de alta.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      email: {
        label: 'Emails de Alumnos',
        placeholder: 'Escribe aquí las casillas de correo separadas por coma.',
        tooltip: 'Si el o los alumnos ya pertenecen a la academia serán asignados al mapa, caso contrario sus inscripciones serán habilitadas una vez que confirmen las invitaciones.'
      }
    },

    title: 'Crear Inscripción',

    validation: {
      email: {
        email: 'El email ingresado no es una cuenta válida.',
        required: 'Email de nuevo alumno es requerido.',
        invalid: 'Las siguientes casillas de correo no son válidas:',
        others: 'Y otras',
        more: 'casillas...'
      }
    }
  }
}

export default mEditionMapEnrollmentsStudentsModalCreate
